import * as API from "../../api";
import * as ActionTypes from "../action-types";

import { message } from 'antd'

// Redux Action
import { 
    setLoadingReport, 
    unsetLoadingReport
} from './style'

export const get_driver_report_summary_request = (items, cb) => dispatch => {
    dispatch(setLoadingReport())

    return API
    .getDriverReportSummary(items)
    .then(info => {
        
        try { 
            const {
                report,
                events
            } = info

            report && dispatch(get_driver_report_summary_success(report, events))
            cb()


        } catch(err) {
            message.error('Error in getting driver summary report. Refresh page?')
        }
    }).finally(() => dispatch(unsetLoadingReport()))
    
}

const get_driver_report_summary_success = (reports, events) => {
    return {
        type: ActionTypes.GET_DRIVER_REPORTS,
        reports,
        events
    }
}

export const get_device_log_report_summary_request = (items, cb) => dispatch => {
    dispatch(setLoadingReport())

    return API
    .getDeviceReportSummary(items)
    .then(info => {
        
        try { 
            const {
                reports
            } = info

            reports && dispatch(get_device_log_report_summary_success(reports))
            cb()


        } catch(err) {
            message.error(err)
        }
    }).finally(() => dispatch(unsetLoadingReport()))
    
}


const get_device_log_report_summary_success = (reports) => {
    return {
        type: ActionTypes.GET_DEVICE_REPORTS,
        reports
    }
}

export const unset_device_log_report_summary_success = () => {
    return {
        type: ActionTypes.UNSET_DEVICE_REPORTS
    }
}